<template>
  <v-container :class="containerClass" fluid>
    <classroom-schedule-form mode="add" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            left
            :href="$route('classroom-schedules.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Create new class schedule</h2>
        </div>
      </template>
    </classroom-schedule-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import ClassroomScheduleForm from '@components/ClassroomSchedule/Form'
export default {
  components: {
    ClassroomScheduleForm,
  },
  layout: LayoutDashboard,
  methods: {
    onCancel() {
      window.location.href = this.$route('classroom-schedules.index')
    },
  },
}
</script>
